import { Button, message, Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import api from "@/v1/api";
import type { IUser } from "@/v1/types";
import { CreateUserForm, CreateUserFormValues } from "./CreateUserForm";
export const CreateUser = ({
  onCreateUser,
}: {
  onCreateUser: (newUser: IUser) => void;
}) => {
  const { t } = useTranslation("CreateUser");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleReset = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async (values: CreateUserFormValues) => {
    const newUser = await api.kontax.createUser(values);
    setIsModalOpen(false);
    message.success(t("success"));
    onCreateUser(newUser);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        {t("button.addCustomer")}
      </Button>
      <Modal
        title={t("title")}
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={null}
        width={800}
      >
        <CreateUserForm onSubmit={handleSubmit} onReset={handleReset} />
      </Modal>
    </>
  );
};
